<template>
  <StringField
    :type='isFilterField && modelValue === "__EMPTY__" ? "text" : "number"'
    :label='label'
    :record='record'
    :disabled='disabled'
    :name='name'
    :edit-mode='editMode'
    :field='field'
    :is-filter-field='isFilterField'
    :error='error'
    :model-value='modelValue'
    :input-classes='inputClasses'
    :help='help'
    @update:model-value='updateValue($event)'
  />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import useInputFieldBase, { InputFieldProps, InputFieldComponents, InputFieldEmits } from '../../../compositions/useInputFieldBase'
  import useInputFieldHasHelp, { InputFieldHasHelpProps, InputFieldHasHelpComponents } from '../../../compositions/useInputFieldHasHelp'
  import StringField from '@/components/inputs/string-field/StringField.vue'

  export default defineComponent({
    name: 'NumberField',
    components: {
      StringField,
      ...InputFieldComponents,
      ...InputFieldHasHelpComponents,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
      type: {
        type: String,
        default: 'text',
      },
      withIcon: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: null,
      },
    },
    emits: [
      ...InputFieldEmits,
      'has-focus',
    ],
    setup() {
      const { helpVisible, setHelpModalVisibility } = useInputFieldHasHelp()
      const { updateValue, getLabel } = useInputFieldBase()

      return {
        updateValue, getLabel, helpVisible, setHelpModalVisibility,
      }
    },
  })
</script>
